


































import { Maybe, Query, SubscriptionBase } from '@/types/generated/graphql'
import Vue from 'vue'
import SubscriptionsQuery from '@/graphql/order/subscriptions.gql'
import GqlQuery from '@/components/atoms/Gql/GqlQuery.vue'
import XPagination from '@/components/atoms/Pagination/XPagination.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import SubscriptionSearch, { Input } from './SubscriptionSearch.vue'
import Subscription from './Item/Subscription.vue'

type Data = {
  subscriptions: Array<SubscriptionBase>
  pagination: {
    first: number
    page: number
    totalPage: number
    caption: {
      total: number
      from?: Maybe<number>
      to?: Maybe<number>
    }
  }
  input: Input
}

type Methods = {
  update: (query: Query) => SubscriptionBase[]
  refresh: () => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: 'SubscriptionList',
  components: {
    GqlQuery,
    XPagination,
    XCard,
    SubscriptionSearch,
    Subscription,
  },
  data() {
    return {
      query: SubscriptionsQuery,
      subscriptions: [],
      pagination: {
        first: 10,
        page: 1,
        totalPage: 0,
        caption: {
          total: 0,
          from: 0,
          to: 0,
        },
      },
      input: {},
    }
  },
  computed: {
    variables() {
      const { first, page } = this.pagination
      return { input: this.input, first, page }
    },
  },
  methods: {
    update({ subscriptions }: Query) {
      const { data, paginatorInfo } = subscriptions
      this.subscriptions = data
      this.pagination = {
        ...this.pagination,
        page: paginatorInfo.currentPage,
        totalPage: paginatorInfo.lastPage,
        caption: {
          total: paginatorInfo.total,
          from: paginatorInfo.firstItem,
          to: paginatorInfo.lastItem,
        },
      }
      return data
    },
    refresh() {
      const queryTable = this.$refs.queryTable as any
      queryTable.refetch()
    },
  },
})
